import { Disc3, Moon, Sun } from "lucide-react";
import { useEffect } from "react";
import { Link, NavLink, Outlet, useLocation } from "react-router-dom";
import { PlayerBar, PlayerProvider } from "../player";
import { useTheme } from "../theme";
import { SearchBox } from "./SearchBox";

export function Layout() {
  const { pathname } = useLocation();
  const { theme, toggle } = useTheme();
  useEffect(() => window.scrollTo(0, 0), [pathname]);
  return (
    <PlayerProvider>
      <a className="skip" href="#main">Przejdź do treści</a>
      <header className="topbar">
        <div className="wrap topbar__in">
          <Link to="/" className="brand" aria-label="Poplista, strona główna">
            <span className="brand__mark"><Disc3 size={20} strokeWidth={2.2} aria-hidden="true" /></span>
            Poplista
          </Link>
          <nav aria-label="Główne">
            <NavLink to="/listy/rmf-fm-poplista">Listy</NavLink>
            <NavLink to="/odkrywaj">Odkrywaj</NavLink>
            <NavLink to="/o-projekcie">O projekcie</NavLink>
          </nav>
          {pathname !== "/" && (
            <div className="topbar__search">
              <SearchBox />
            </div>
          )}
          <div className="topbar__tools">
            <button
              type="button"
              className="theme-toggle"
              onClick={toggle}
              aria-label={theme === "dark" ? "Włącz jasny motyw" : "Włącz ciemny motyw"}
              title={theme === "dark" ? "Jasny motyw" : "Ciemny motyw"}
            >
              {theme === "dark" ? <Sun size={18} aria-hidden="true" /> : <Moon size={18} aria-hidden="true" />}
            </button>
          </div>
        </div>
      </header>
      <main id="main" className="wrap">
        <Outlet />
      </main>
      <footer className="footer">
        <div className="wrap">
          <span>
            Dane pochodzą z publicznych stron rozgłośni; okładki i próbki należą do ich właścicieli.
          </span>
          <Link to="/o-projekcie">Źródła</Link>
        </div>
      </footer>
      <PlayerBar />
    </PlayerProvider>
  );
}
